import {
	Button,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material'
import React from 'react'
import { TableSelection } from '../../services/DialogService'

type TablePickerProps = {
	configuration: TableSelection
	onClose: (v?: unknown) => void
}

function executeSelector(
	selector: string | ((v: unknown) => string | number | boolean),
	element: Record<string, unknown>,
): string | number | boolean {
	if (typeof selector === 'string')
		return element[selector] as string | number | boolean
	return selector(element)
}

export const TablePicker: React.FC<TablePickerProps> = ({
	configuration,
	onClose,
}: TablePickerProps) => {
	return (
		<TableContainer component={Paper}>
			<Table>
				<TableHead>
					<TableRow>
						{configuration.headers.map((header, i) => (
							<TableCell key={i}>{header.displayName}</TableCell>
						))}
						<TableCell />
					</TableRow>
				</TableHead>
				<TableBody>
					{configuration.values.map((value, i) => (
						<TableRow key={i}>
							{configuration.headers.map((header, i) => (
								<TableCell key={i}>
									{executeSelector(header.selector, value)}
								</TableCell>
							))}
							<TableCell>
								<Button variant="contained" onClick={() => onClose(value)}>
									Select
								</Button>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
